import { createAssignmentSelectors } from "../createAssignmentWidgetSlice";

const { selectData, selectLoading, selectError } = createAssignmentSelectors("proposalAssignment");

export const selectProposalAssignmentData = selectData;
export const selectProposalAssignmentLoading = selectLoading;
export const selectProposalAssignmentError = selectError;
